import React, { useEffect, useState } from "react";
import "./Operator.scss";
import TableFilterHeader from "../../components/TableHeader/TableFilterHeader";
import { useSelector, useDispatch } from "react-redux";
import { getUserList } from "../../store/redux/users";
import { getUsers } from "../../util/API/customers";
import TableInfoHeaderAgent from "../../components/TableInfoHeader/TableInfoHeaderAgent";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import OperatorTable from "../../components/OperatorTable/OperatorTable";
import OperatorCreation from "../../components/OperatorComponents/OperatorCreation/OperatorCreation";
import OperatorDetail from "../../components/OperatorComponents/OperatorDetail/OperatorDetail";
import { ListOperators } from "../../util/API/operator";
import { getOperatorsList } from "../../store/redux/operator";
import { GetOperatorsWithID } from "../../util/API/operator";
import { getUserRoles } from "../../util/API/login";
import { Box, Button, Typography } from "@mui/material";
import BaseDrawer from "../../components/UI/BaseDrawer/BaseDrawer";
import { getSystemStatus } from "../../util/API/admin";
function Operator() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filterType, setFilterType] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [operatorDetails, setOperatorDetails] = useState({
    firstName: "",
    lastName: "",
    businesscountry: "",
    email: "",
    subaccountEmail: "",
    status: "",
    phoneno: "",
  });
  const [operators, setOperators] = useState([]);
  const [securityPermissions, setSecurityPermissions] = useState([]);
  const requiredConstants = useSelector((state) => state.constants);
  const [userStatus, setUserStatus] = useState([])

  //Security Roles

  const securityAccess = useSelector((state) => state.login.securityAccess);
  const userInfo = useSelector((state) => state.login.user);
  useEffect(() => {
    const securityUser = searchAppsByLabel("agent", securityAccess);
    if (securityUser.length) {
      setSecurityPermissions(securityUser[0]);
    }
    adminPortalStatus();
  }, []);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  async function getList() {
    let userList = await getUsers();
    dispatch(getUserList({ users: userList }));
  }
  useEffect(() => {
    getList();
  }, []);
  
  useEffect(() => {
    let filtered
    if (operators) {
      // console.log(operators)
      if (searchText.trim() === "") {
        
        if (Array.isArray(operators?.VusersubacctRecs)) {
          filtered = [...operators.VusersubacctRecs].reverse();
        } else if (operators?.VusersubacctRecs) {
            filtered = [operators.VusersubacctRecs];
        } else {
            filtered = [];
        }
      
      setFilteredUsers(filtered.sort((a, b) => b.Vusersubacct.subacctid - a.Vusersubacct.subacctid));
      } else {
        // filtered = operators?.VusersubacctRecs?.filter(
        //   (operator) =>
        //     String(operator.Vusersubacct.firstName)
        //       .toLowerCase()
        //       .includes(searchText.toLowerCase()) ||
        //       operator.Vusersubacct.countryname
        //       .toLowerCase()
        //       .includes(searchText.toLowerCase())
        // );
        filtered = operators?.VusersubacctRecs?.filter((operator) =>
          String(operator.Vusersubacct.firstName)
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          operator.Vusersubacct.countryname
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          operator.Vusersubacct.emailAccount
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) || // Check emailAccount
          operator.Vusersubacct.lastName
            ?.toLowerCase()
            .includes(searchText.toLowerCase())    // Check lastName
        );
        setFilteredUsers(filtered.sort((a, b) => b.Vusersubacct.subacctid - a.Vusersubacct.subacctid));
      }
    }
  }, [operators, searchText]);
  
  const fetchOperators = async () => {
    const response = await ListOperators(userInfo.id);
    if (response?.payload) {
      let operatorsList = response.payload.data;
      setOperators(operatorsList);
      dispatch(getOperatorsList({ users: operatorsList }));
    } else {
      dispatch(getOperatorsList({ users: [] }));
    }
  };

  useEffect(() => {
    fetchOperators();
  }, []);

  const setFilter = (filter) => {
    setFilterType(filter);
  };
  const handleSelectedUser = async (selectedOperator) => {
    setSelectedUser(selectedOperator.subacctid);

    // console.log(selectedOperator)

    const userDetails = await GetOperatorsWithID(
      selectedOperator.subacctid
    ).then((response) => {
      if (response) {
        // console.log(response)
        setSelectedUserData(response.CustomerData);
        // console.log(response.CustomerData)
        setOperatorDetails({
          firstName: response.CustomerData.User.firstName,
          lastName: response.CustomerData.User.lastName,
          businesscountry: response.CustomerData.User.countryid,
          email: response.CustomerData.User.other1,
          subemail: selectedOperator.emailAccount,
          // status: selectedOperator.active,
          status: response.CustomerData.User.status,
          phoneno: response.CustomerData.User.telephoneno,
          subuserid: response.CustomerData.User.id,
        });
      }
    });
    setOpenDetail(true);
  };

  const handleSearch = (searchText) => {
    setSearchText(searchText);
    if (searchText.trim() === "") {
      setFilteredUsers(operators?.VusersubacctRecs);
    } else {
      // const filtered = operators.VusersubacctRecs.filter(
      //   (operator) =>
      //     operator.Vusersubacct.firstName
      //       .toLowerCase()
      //       .includes(searchText.toLowerCase()) ||
      //       operator.Vusersubacct.countryname
      //       .toLowerCase()
      //       .includes(searchText.toLowerCase())
      // );
      const filtered = operators.VusersubacctRecs.filter(
        (operator) =>
          (operator?.Vusersubacct?.firstName
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.countryname
              .toLowerCase()
              .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.emailAccount
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            operator?.Vusersubacct?.lastName
              ?.toLowerCase()
              .includes(searchText.toLowerCase()))
      );
      // console.log("setFilteredUsers==============",filtered);
      setFilteredUsers(filtered);
    }
  };

  const handleUserCreated = () => {
    fetchOperators(); // Reload the list of operators
  };

  const adminPortalStatus = async() => {
    const response = await getSystemStatus();
    setUserStatus(response.RunQuery4Class.data.body.payload);
  }

  return (
    <>
      {filteredUsers ? (
        <>
          <OperatorCreation 
            open={open} 
            handleClose={handleClose}
            onUserCreated={handleUserCreated}
          />
          <Box className="page-container crm-container">
            <Box>
              <Box
                className={`page-title ${
                  scrollPosition > 105 ? "fixed-filter-header" : ""
                }`}
                style={{ transition: "all 0.5s ease-in-out" }}
              >
                <Box className="crm-row-style">
                  <Typography
                  variant="h9"
                    className={scrollPosition > 105 ? "hide" : "padding-header"}
                  >
                    Operators
                  </Typography>
                  <TableFilterHeader
                    handleSearch={handleSearch}
                    setOpen={handleOpen}
                    createAllowed={1}
                    placeholder={"Search Operators"}
                  />
                </Box>
              </Box>
            </Box>
            <Box className="customer-table-container mb-4">
              <TableInfoHeaderAgent
                count={operators.recount}
                setFilter={setFilter}
                handleOpen={handleOpen}
                user={"Operators"}
              />
              <OperatorTable
                operatorData={filteredUsers}
                handleSelectedUser={handleSelectedUser}
                targetID="offcanvasRightLoan"
                systemRoles={requiredConstants.systemRoles}
                userStatus={userStatus}
              />
            </Box>
            <Box
              className="offcanvas offcanvas-end dynamic-offcanvas"
              tabIndex="-1"
              id="offcanvasRightLoan"
              aria-labelledby="offcanvasRightLabel"
            >
              <Box className="customer-bottom-info">
                <Box className="text-end p-2">
                  <Button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></Button>
                </Box>
                <BaseDrawer
                  open={openDetail}
                  handleClose={() => setOpenDetail(false)}
                  height="90vh"
                  title={"Operator Account Details"}
                >
                  <Box className="customer-bottom-box2">
                    <OperatorDetail
                      selectedUser={selectedUser}
                      setSelectedUserData={setSelectedUserData}
                      operatorDetails={operatorDetails}
                      handleClose={() => setOpenDetail(false)}
                      fetchOperators={fetchOperators}
                    />
                  </Box>
                </BaseDrawer>
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box />
      )}
    </>
  );
}
export default Operator;